module.exports = __webpack_public_path__ + "static/media/sofie_avatar.b318e379.png";